import api from './api';

export interface OrgItemRecord {
  id: string;
  name: string;
  isActive: boolean;
  userCount: number;
  postCount: number;
  pollCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateOrgItemPayload {
  name: string;
}

export interface UpdateOrgItemPayload {
  name?: string;
  isActive?: boolean;
}

export const organizationService = {
  async getPickerBranches(): Promise<string[]> {
    const { data } = await api.get<string[]>('/organization/picker/branches');
    return Array.isArray(data) ? data : [];
  },

  async getPickerDepartments(branch?: string): Promise<string[]> {
    const { data } = await api.get<string[]>('/organization/picker/departments', {
      params: branch?.trim() ? { branch: branch.trim() } : undefined,
    });
    return Array.isArray(data) ? data : [];
  },

  async listBranches(): Promise<OrgItemRecord[]> {
    const { data } = await api.get<OrgItemRecord[]>('/organization/branches');
    return Array.isArray(data) ? data : [];
  },

  async listDepartments(): Promise<OrgItemRecord[]> {
    const { data } = await api.get<OrgItemRecord[]>('/organization/departments');
    return Array.isArray(data) ? data : [];
  },

  async createBranch(payload: CreateOrgItemPayload): Promise<OrgItemRecord> {
    const { data } = await api.post<OrgItemRecord>('/organization/branches', payload);
    return data;
  },

  async createDepartment(payload: CreateOrgItemPayload): Promise<OrgItemRecord> {
    const { data } = await api.post<OrgItemRecord>('/organization/departments', payload);
    return data;
  },

  async updateBranch(id: string, payload: UpdateOrgItemPayload): Promise<OrgItemRecord> {
    const { data } = await api.patch<OrgItemRecord>(`/organization/branches/${id}`, payload);
    return data;
  },

  async updateDepartment(id: string, payload: UpdateOrgItemPayload): Promise<OrgItemRecord> {
    const { data } = await api.patch<OrgItemRecord>(`/organization/departments/${id}`, payload);
    return data;
  },

  async deleteBranch(id: string): Promise<void> {
    await api.delete(`/organization/branches/${id}`);
  },

  async deleteDepartment(id: string): Promise<void> {
    await api.delete(`/organization/departments/${id}`);
  },
};
